var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("password", {
    attrs: {
      defaultClass: "form-control" + (_vm.error ? " is-invalid" : ""),
      name: _vm.id,
      placeholder: _vm.placeholder,
      id: _vm.id,
      toggle: true,
      showStrengthMeter: _vm.showStrengthMeter,
      badge: _vm.badge,
      secureLength: _vm.secureLength,
    },
    model: {
      value: _vm.password,
      callback: function ($$v) {
        _vm.password = $$v
      },
      expression: "password",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }